export class ImportData {
  header: string;
  field?: string;
  error?: string;
}
